/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate HTTP proxy
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.20.2-27-g52fb3b68-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the NewApiToken interface.
 */
export function instanceOfNewApiToken(value) {
    if (!('label' in value) || value['label'] === undefined)
        return false;
    if (!('expiry' in value) || value['expiry'] === undefined)
        return false;
    return true;
}
export function NewApiTokenFromJSON(json) {
    return NewApiTokenFromJSONTyped(json, false);
}
export function NewApiTokenFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'label': json['label'],
        'expiry': (new Date(json['expiry'])),
    };
}
export function NewApiTokenToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'label': value['label'],
        'expiry': ((value['expiry']).toISOString()),
    };
}
